<template>
  <el-container>
    <!-- 头部区域 -->
    <el-header class="header">
      <el-row :gutter="20" style="line-height: 75px;">
        <el-col :span="4" style="font-size: 26px;text-align: left;">
          <img src="../assets/logo_bj.png" >
        </el-col>
        <el-col :span="14">
          <div class="grid-content ep-bg-purple">
          </div>
        </el-col>
        <el-col :span="6" style="text-align: end">
          <el-row :gutter="20">
            <el-col :span="16" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: left;">
              当前用户：<span style="color: darkorange;font-size: 22px"> {{ userInfo==null?"":userInfo.name }}</span>
            </el-col>
            <el-col :span="8">
              <el-button type="info" @click="logout">退出</el-button>
            </el-col>
          </el-row>

        </el-col>
      </el-row>

    </el-header>
    <el-container style="height: 100%">
      <!-- 侧边栏区域 -->
      <left></left>
      <!-- 右侧主体区域 -->
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>

</template>

<script>
import left from "@/layout/Left";

export default {
  name: "layout",
  components: {left},
  data() {
    return {
      userInfo: {
        name: "默认值"
      }
    }
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("UserInfo"));

    if (!this.userInfo) {
      this.logout()
    }
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("UserInfo");
      this.$router.push("/login")
    },
  }
}
</script>

<style>
.el-container.is-vertical {
  height: 100%;
}

.header {
  color: white;
  background-color: #000000;
  height: 110px;
  font-weight: bold;
}

.el-scrollbar__view {
  display: block !important;

}
</style>